import styled from 'styled-components';

const SIDEBAR_WIDTH = 255;

export const Layout = styled.div<{ headerheight?: number }>`
  display: flex;
  flex: auto;
  flex-direction: row;
  min-height: 0;
  background: var(--white-100);
  height: calc(100vh - 100px);
`;

// sidebar with open menu inline is causing some overlap issue
// hence the custom layout

export const Sider = styled.div`
  width: ${SIDEBAR_WIDTH}px;
  border: 1px solid var(--gray-10);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Content = styled(Layout)`
  flex-direction: column;

  flex: auto;
  min-height: 0;
  height: 100%;
  width: calc(100vh - ${SIDEBAR_WIDTH}px);
`;
